export default __webpack_public_path__ + "static/Messaging Platform – The Construct – 1920x680-1e9f9dbae12e0bfdfc071b5f4a999ff4.jpg";